import YoutubeSvg from '../assets/img/youtube.svg'
import XSvg from '../assets/img/x.svg'
import TelegramSvg from '../assets/img/telegram.svg'
import DiscordSvg from '../assets/img/discord.svg'
import InstagramSvg from '../assets/img/instagram.svg'
export const socialNetworks = [
    {
        icon: XSvg,
        name: 'x',
        href: 'https://www.twitter.com/DucklingsS87723',
    },
    {
        icon: InstagramSvg,
        name: 'instagram',
        href: 'https://www.instagram.com/ducklingsstudio/',
    },
    {
        icon: YoutubeSvg,
        name: 'youtube',
        href: 'https://www.youtube.com/@DucklingsStudio',
    },
    {
        icon: DiscordSvg,
        name: 'discord',
        href: 'https://www.discord.com/invite/qxTQCBFaVr',
    },
    {
        icon: TelegramSvg,
        name: 'telegram',
        href: 'https://t.me/DucklingsStudio',
    }
]